export default __webpack_public_path__ + "static/media/simTransfer-1.d1005d7b.png";